(() => {
  function initialize(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const photo = root.querySelector('#product-photo');
    const thumbnails = root.querySelectorAll('[data-gallery-src]');
    thumbnails.forEach(button => button.addEventListener('click', () => {
      photo.src = button.dataset.gallerySrc;
      photo.alt = button.dataset.galleryAlt;
      thumbnails.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    }));
  }
  document.querySelectorAll('.ry-dollhouse').forEach(initialize);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('.ry-dollhouse').forEach(initialize);
  });
})();
